import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, convertToParamMap } from '@angular/router';
import { faPlus, faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';
import { combineLatest, merge, Observable, of, Subscription } from 'rxjs';
import { map, pairwise, scan, switchMap } from 'rxjs/operators';
import { NamSelectedObjectService } from 'src/app/servizi/nam/nam-object-selected.service';
import { NamService } from 'src/app/servizi/nam/nam.service';
import { RelatedItemInterface, RelatedItemsInterface } from './model/related-item.interface';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MODALS } from './modal/modals';
import { createRelativeItemFromFeatureAndConfig, createRelativeItemFromUrnAndConfig, getCollectionName, mapNumbers, staticImagePixelFromCoordinates } from './object-utils';
import { ProjectService } from "src/app/servizi/nam/project.service";
import { transform } from 'ol/proj';
import { Collection } from '../object-info/model/config-api-response.interface';
// import { MappaService } from 'src/app/servizi/mappa/mappa.service';
import { extentFromWorldInfo } from '../../home/object-info/create-static-image-layer-source';
import { TemplateService } from 'src/app/servizi/nam/template.service';
import { WorldService } from 'src/app/servizi/nam/world.service';
// import { DynamicConfigService } from 'src/app/servizi/nam/dynamic-config.service';
import { EditFeatureService } from 'src/app/servizi/nam/edit-feature.service';
import { EbwModalService } from 'src/app/library/ebw-modals-angular/ebw-modal.service';


@Component({
  selector: 'app-object-info',
  templateUrl: './object-info.component.html',
  styleUrls: ['./object-info.component.scss'],
})
export class ObjectInfoComponent implements OnInit, OnDestroy {
  token: string = null;
  systemSource: string = null;
  idOperazione: string = null;
  urn: string = null;
  deletable: boolean = false;

  objectData: any = {};
  relatedItems: RelatedItemsInterface = [];
  breadcrumbs$: Observable<[RelatedItemInterface, RelatedItemInterface]>;
  relatedItemsHistory;
  subs: Subscription[] = [];

  icons = { faPlus, faArrowUpRightFromSquare };
  collections: Collection[];

  canObjectBeDeleted$: Observable<boolean>;

  constructor(
    private route: ActivatedRoute,
    private namService: NamService,
    private namSelectedObjectService: NamSelectedObjectService,
    public projectService: ProjectService,
    private worldService: WorldService,
    private _modalService: NgbModal,
    public templateService: TemplateService,
    public editGeometryService: EditFeatureService,
    private ebwModalService: EbwModalService
  ) {
    // 
    this.breadcrumbs$ = namSelectedObjectService.selectedObjectForInfo$.pipe(pairwise());
    // 
    this.relatedItemsHistory = merge(
      namSelectedObjectService.selectedObjectForInfo$.pipe(map((x) => (s) => [...s, x].slice(-15))), // append to list
      namSelectedObjectService.selectedIndexFromObjectHistory$.pipe(
        map((x) => (s) => {
          return x !== -1 ? s.slice(0, x + 1) : s;
        })
      )
    ).pipe(scan((list, reducer) => reducer(list), []));
    // 
    this.canObjectBeDeleted$ = namSelectedObjectService.selectedObjectForInfo$.pipe(
      switchMap((selectedObjectForInfo) =>
        !!projectService?.projectId ?
          this.namService.getEditsInProject(projectService.projectId).pipe(
            map((result) => {
              if (result && result.error != undefined && result.error == 0) {
                const compatibles = result.data.filter((element) => element.urn == selectedObjectForInfo.urn);
                if (compatibles.length > 0 && compatibles[0].operation == 'insert') {
                  return true;
                } else {
                  return false;
                }
              }
            })
          ) : of(false)
      )
    );    
  }

  ngOnInit() {
    this.subscriptions();
  }

  ngOnDestroy(): void {
    this.subs.forEach((s) => s.unsubscribe());
  }

  subscriptions() {
    this.subs.push(
      this.namService.getSelectedCoordinatesFromMapService().subscribe((coord) => {
        // todo : call restrictedArea/select with the coords
        //TODO: make it dynamic!
        let worldInfo = this.worldService.getWorldInfo();
        let coordinates = coord[0];
        let latLng = transform(coordinates, 'EPSG:3857', 'EPSG:4326');
        let staticImageExtent = extentFromWorldInfo(this.worldService.getWorldInfo()); //TODO make it a service!
        let imageSize = [1024, 1024];
        let pixelCoordinates = staticImagePixelFromCoordinates(staticImageExtent, imageSize, coordinates);

        //Remove data from popup and remove it
        this.namService.namPopupContent = [];
        if (this.namService.popupIsOpen) {
          this.namService.closePopup();
        } else {
          this.namService.closePopup();

          // Map pixel coordinates to world coordinates. // extract map da utils
          let xCoord = mapNumbers(pixelCoordinates[0], 0, imageSize[0], worldInfo.bounds.xmin, worldInfo.bounds.xmax);
          let yCoord = mapNumbers(pixelCoordinates[1], 0, imageSize[1], worldInfo.bounds.ymin, worldInfo.bounds.ymax);

          // Call select to get features in the clicked coordinate.
          combineLatest([
            this.namService.getApiConfiguration(),
            this.namService.selectByCoordinate(xCoord, yCoord, worldInfo, (worldInfo.bounds.xmax - worldInfo.bounds.xmin) / 1e9)
          ]).subscribe(([configAPI, data]) => {

            this.namService.namPopupContent = data.result["features"].filter((element: any) => {
              let elementCollection = getCollectionName(element.id);
              return this.collections.findIndex(collectionItem => {
                return collectionItem.name.includes(elementCollection);
              }) != -1;
            }).map(f => createRelativeItemFromFeatureAndConfig(f, configAPI));

            this.namService.openPopup(coordinates);
          });
        }
      })
    );

    this.subs.push(
      this.namSelectedObjectService.getSelectedObjectByUrnAndRelatedItems().subscribe(
        ({ response, relatedItems }) => {
          this.relatedItems = relatedItems;
          let urnData = response?.result ? response?.result : (response?.data as any); // todo: remove any type
          if (urnData?.features[0]?.properties) {
            this.objectData = urnData.features[0];
            //  Fetch current world info.  // callback non va bene ?
            this.worldService.fetchWorldInfo(urnData.features[0].id);
          } else {
            this.objectData = {};
          }
        },
        (error) => {
          console.log('ERROR', error);
          this.objectData = {};
          this.relatedItems = [];
            this.ebwModalService.openErrorModal({
              title: "Errore applicativo",
              content: error.message
           });
        }
      )
    );

    this.subs.push(
      combineLatest([this.namService.getApiConfiguration(), this.route.queryParams]).subscribe(
        ([apiConfig, params]) => {
          // console.log({ apiConfig, params });
          const paramMap = convertToParamMap(params);
          // todo: uncomment when working with real params
          // if(paramMap.has('urn') && paramMap.has('token') && paramMap.has('systemSource') && paramMap.has('idOperazione') && apiConfig?.data) {}
          this.token = paramMap.get('token');
          this.systemSource = params.systemSource;
          this.idOperazione = paramMap.get('idOperazione');
          this.systemSource = paramMap.get('systemSource');
          this.urn = params.urn;
          this.collections = apiConfig.data.collections;
          //this.urn = 'swrefVrecordVdatasetZgisVcollectionZmit_hubVkeysZ4026609553144531691';
          const objectAsRelatedItem: RelatedItemInterface = createRelativeItemFromUrnAndConfig(
            this.urn,
            apiConfig
          );
          if (objectAsRelatedItem) this.handleSelectedObject(objectAsRelatedItem);

          // todo: else => show ERROR or message
        }
      )
    );
  }

  isSnapActive(): boolean {
    if (this.templateService.addingTemplate) {
      return this.templateService.isSnapActive();
    } else if (this.editGeometryService.editingGeometry) {
      return this.editGeometryService.isSnapActive();
    } else {
      return false;
    }
  }

  toggleSnap() {
    if (this.templateService.addingTemplate) {
      this.templateService.toggleSnap();
    } else if (this.editGeometryService.editingGeometry) {
      this.editGeometryService.toggleSnap();
    }
  }

  cancelTemplate() {
    this.templateService.cancelTemplate();
  }

  cancelEditGeometry() {
    this.editGeometryService.cancelEditGeometry();
  }

  handleSelectedObject(item: RelatedItemInterface) {
    this.namSelectedObjectService.selectedObjectForInfo = item;
  }

  clearHistoryAndHandleSelectedObject(selected: { item: RelatedItemInterface, index: number }) {
    this.handleSelectedObject(selected.item);
    requestAnimationFrame(() => (this.namSelectedObjectService.clearHistory = selected.index));
  }

  async sendProject() {
    await this.projectService.sendProject();
    // // Fetch updated information about the currently selected feature after the project is over.
    const configAPI = await this.namService.getApiConfiguration().toPromise();
    const containerAsRelatedItem = createRelativeItemFromUrnAndConfig(this.urn, configAPI);
    this.namSelectedObjectService.selectedObjectForInfo = containerAsRelatedItem;
  }

  sendEditGeometry() {
    this.editGeometryService.sendEditGeometry();
  }

  async deleteProject() {
    await this.projectService.deleteProject();
    // // Fetch updated information about the currently selected feature after the project is over.
    const configAPI = await this.namService.getApiConfiguration().toPromise();
    const containerAsRelatedItem = createRelativeItemFromUrnAndConfig(this.urn, configAPI);
    this.namSelectedObjectService.selectedObjectForInfo = containerAsRelatedItem;
    this.namSelectedObjectService.clearHistory = 0;
  }

  handleOpenTemplatesModal() {
    this._modalService.open(MODALS['templatesContainerComponent'], {
      size: 'lg',
      keyboard: false,
      scrollable: false,
      centered: true,
    });
  }
}
